<div class="group-container" [formGroup]="group" [ngClass]="{'warn':isRulesArrayInvalid()}">
        <div class="group-header">
        <mat-radio-group formControlName="condition" class="toggle-group">
            <mat-radio-button class="import-button aet-btn-table button-and"
                [ngClass]="{'selected': group?.get('condition')?.value === 'AND'}" value="AND">
                AND
            </mat-radio-button>
            <mat-radio-button class="import-button aet-btn-table button-or"
                [ngClass]="{'selected': group?.get('condition')?.value === 'OR'}" value="OR">
                OR
            </mat-radio-button>
        </mat-radio-group>

        <div>
            <button type="button" class="import-button aet-btn-table" (click)="addRule()">Add Rule</button>
            <button type="button" class="import-button aet-btn-table" (click)="addGroup(group)">Add Group</button>
            <button type="button" class="import-button aet-btn-table rule-delete-btn" *ngIf="!isRootGroup" (click)="removeThisGroup()">Delete Group</button>
        </div>
    </div>

    <!-- List of Rules -->
    <div formArrayName="rules">
        <div class="rule-group" *ngFor="let rule of rulesArray.controls; let i = index" [formGroupName]="i">
            <div class="rule-fields">
                <mat-form-field appearance="fill" class="fields-w">
                    <mat-label>Field ID</mat-label>
                    <mat-select formControlName="fieldId">
                      <mat-option value="">No filter</mat-option>
                      <mat-option *ngFor="let value of options" [value]="value?.id">
                        {{ value?.label }}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                  

                <!-- Operator Field (Hidden if no fieldId selected) -->
                <mat-form-field *ngIf="rule?.get('fieldId')?.value" class="fields-w">
                    <mat-label>Operator</mat-label>
                    <mat-select formControlName="fieldOper">
                        <mat-option *ngIf="!(findValueById(rule?.get('fieldId')?.value, 'operators') || []).length"
                            disabled>
                            No operators available
                        </mat-option>
                        <mat-option *ngFor="let value of (findValueById(rule?.get('fieldId')?.value, 'operators') || [])"
                            [value]="value">
                            {{ value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Value Field (Hidden if no fieldId selected) -->
                <mat-form-field *ngIf="rule?.get('fieldId')?.value" class="fields-w">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue">
                        <mat-option *ngIf="!(findValueById(rule?.get('fieldId')?.value, 'values') || []).length"
                            disabled>
                            No values available
                        </mat-option>
                        <mat-option *ngFor="let value of (findValueById(rule?.get('fieldId')?.value, 'values') || [])"
                            [value]="value.key">
                            {{ value.value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <button type="button" class="import-button aet-btn-table rule-delete-btn" (click)="removeRule(i)">Delete</button>
        </div>
    </div>

    <!-- Recursively Render Sub-Groups -->
    <div formArrayName="group">
        <div *ngFor="let subgroup of groupArray?.controls; let j = index" [formGroupName]="j">
            <app-criteria [group]="subgroup" [options]="options" [isRootGroup]="false">
            </app-criteria>
        </div>
    </div>
</div>